var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.111 0A16.111 16.111 0 0 1 27.5 27.5 16.111 16.111 0 0 1 4.719 4.719 16 16 0 0 1 16.111 0m0 30.222a14.111 14.111 0 1 0-9.978-4.133 14.02 14.02 0 0 0 9.978 4.133",
    "data-name": "Path 191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 34a1 1 0 0 1-.707-.293l-3.867-3.867a1 1 0 0 1 1.414-1.414l3.867 3.867A1 1 0 0 1 33 34",
    "data-name": "Path 192"
  }))));
};
export default SvgSearch;